export enum ENTRIES_REFERENCE_CATEGORIES {
  LEDGER = 'LEDGER',
  LEDGER_TYPE = 'LEDGER TYPES',
}
export enum TRANS_TYPES {
  CREDIT = 'Credit',
  DEBIT = 'Debit',
}
